/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { UPDATE_DTW_OPTIONS, UPDATE_SELECTED_DTW } from './DTW-ActionTypes';

const dtwInitalState = {};
const dtwReducer = (state = dtwInitalState, action) => {
    switch (action.type) {
        case UPDATE_DTW_OPTIONS:
            return {
                ...state,
                [action.data.cartItemId]: { dtwOptions: action.data },
            };
        case UPDATE_SELECTED_DTW:
            return {
                ...state,
                selectedDTW: action.data,
            };
        default:
            return state;
    }
};

export default dtwReducer;
